
import React from 'react';

export const GenerateIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9.5 2.5a1.5 1.5 0 0 1 3 0" />
    <path d="M6.13 4.13a1.5 1.5 0 0 1 2.12 0" />
    <path d="M2.5 9.5a1.5 1.5 0 0 1 0-3" />
    <path d="M4.13 15.87a1.5 1.5 0 0 1 0 2.12" />
    <path d="M9.5 21.5a1.5 1.5 0 0 1-3 0" />
    <path d="M15.87 17.87a1.5 1.5 0 0 1 2.12 0" />
    <path d="M21.5 12.5a1.5 1.5 0 0 1 0-3" />
    <path d="M17.87 6.13a1.5 1.5 0 0 1 0-2.12" />
    <path d="M12 8a4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4Z" />
  </svg>
);
